<template>
    <div class="home__container">
        <LoadingScreen v-if="isLoadingScreen"></LoadingScreen>
        <template v-else>
            <div class="home__request-timeout" v-if="isTimeOut">
                {{ getTranslatedText('Request timeout. Please check your network connection.') }}
            </div>
            <template v-else>
                <div class="home__logo">
                    <img src="~ThemePath/images/logo.png" />
                    <div class="home__version">
                        {{ handleTextAppVersion() }}
                    </div>
                </div>
                <div class="home__title">
                    {{ getTranslatedText('dashboard') }}
                </div>
                <div class="home__items__container">
                    <template v-if="!$store.state.isOnlyPayment">
                        <div v-if="$store.state.isShowSports" @click="$router.push('/sports')" class="home__item home__item__sport">
                            <img src="~ThemePath/images/sports.png" />
                            <div class="home__item__title">
                                {{ getTranslatedText('bitville-sports') }}
                            </div>
                        </div>
                        <div v-if="$store.state.isShow590" @click="onOpenLoto('/loto', 1)" class="home__item home__item__lotto__590">
                            <img src="~ThemePath/images/lotteries.png" />
                            <div class="home__item__title">
                                {{ getTranslatedText('Loto 5/90') }}
                            </div>
                        </div>
                        <div 
                            v-if="$store.state.isShowPick3" 
                            class="home__item home__item__lotto_pick_3"
                            @click="onOpenLoto(CT_PICK_3.URL_PATH, CT_PICK_3.STEP_CART)" >
                                <img src="~ThemePath/images/lotteries.png" />
                                <div class="home__item__title">
                                    {{ getTranslatedText('pick 3') }}
                                </div>
                        </div>
                        <div v-if="$store.state.isShow645" @click="onOpenLoto('/loto-645', 2)" class="home__item home__item__lotto__645__home">
                            <img src="~ThemePath/images/lotteries.png" />
                            <div class="home__item__title">
                                {{ getTranslatedText('Loto 6/45') }}
                            </div>
                        </div>
                        <div v-if="$store.state.isShow459" @click="onOpenLoto('/loto-459', 3)" class="home__item home__item__lotto__459">
                            <img src="~ThemePath/images/lotteries.png" />
                            <div class="home__item__title">
                                {{ getTranslatedText('loto 4/59') }}
                            </div>
                        </div>
                        <div v-if="$store.state.isShow545" @click="onOpenLoto('/loto-545', 4)" class="home__item home__item__lotto__545">
                            <img src="~ThemePath/images/lotteries.png" />
                            <div class="home__item__title">
                                {{ getTranslatedText('lotto 5 of 45') }}
                            </div>
                        </div>
                        <div v-if="$store.state.isShowInstantLotto" @click="onOpenLoto('/lotto-instant/numbers', 5)" class="home__item home__item__lotto__instant">
                            <img src="~ThemePath/images/lotteries.png" />
                            <div class="home__item__title">
                                {{ getTranslatedText(INSTANT_GAME_TITLE) }}
                            </div>
                        </div>
                    </template>
                    <div v-if="$store.state.isShowVoucher" @click="onOpenLoto('/voucher')" class="home__item home__item__voucher">
                        <img src="~ThemePath/images/voucher.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText('voucher lonaguiweb') }}
                        </div>
                    </div>
                    <div class="home__item home__item__history" @click="$router.push('/history')">
                        <img src="~ThemePath/images/report.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText('HISTORY') }}
                        </div>
                    </div>
                    <div @click="$router.push('/scan-ticket')" class="home__item home__item__scan">
                        <img src="~ThemePath/images/scan.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText('scan') }}
                        </div>
                    </div>
                    <div @click="$router.push('/report')" class="home__items">
                        <div class="home__items__item home__items__item__left">
                            <img src="~ThemePath/images/report.png" />
                            <div class="home__item__title">
                                {{ getTranslatedText('report') }}
                            </div>
                        </div>
                        <div @click="$router.push('/report-final')" class="home__items__item">
                            <img src="~ThemePath/images/report.png" />
                            <div class="home__item__title">
                                {{ getTranslatedText('report final') }}
                            </div>
                        </div>
                    </div>
                    <template v-if="$store.state.isShow645 || $store.state.isShow590">
                        <div class="home__items home__items__2">
                            <div @click="$router.push('/results')" class="home__items__item home__item__result">
                                <img src="~ThemePath/images/result.png" />
                                <div class="home__item__title">
                                    {{ getTranslatedText('result') }}
                                </div>
                            </div>
                            <div @click="$router.push('/promotion-results')" class="home__items__item home__item__promotion_result">
                                <img src="~ThemePath/images/result.png" />
                                <div class="home__item__title">
                                    {{ getTranslatedText('promotion results') }}
                                </div>
                            </div>
                        </div>
                        <div class="home__items home__items__2">
                            <div @click="$router.push('/about')" class="home__items__item home__items__item__left-2">
                                <img src="~ThemePath/images/about.png" />
                                <div class="home__item__title">
                                    {{ getTranslatedText('about') }}
                                </div>
                            </div>
                            <div @click="$router.push('/print')" class="home__items__item home__items__item__right-2">
                                <img src="~ThemePath/images/print.png" />
                                <div class="home__item__title">
                                    {{ getTranslatedText('print') }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else @click="$router.push('/print')" class="home__item home__item__print">
                        <img src="~ThemePath/images/print.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText('print') }}
                        </div>
                    </div>
                    <div @click="$router.push('/print')" class="home__items home__items__3">
                        <div class="home__items__item">
                            <div @click="$router.push('/change-pin')" class="home__item__title">
                                {{ getTranslatedText('Change PIN') }}
                            </div>
                        </div>
                        <div class="home__items__item" @click="handleLogout">
                            <div class="home__item__title">
                                {{ getTranslatedText('logout') }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import AuthService from '@/services/auth.service'
import settingService from '@/services/setting.service'
import LoadingScreen from '@/components/common/loading/index.vue'

import { version } from '../../../package.json'
import { isStrEmpty, setSettingSite } from '@/utils/utils'
import { CT_PICK_3, INSTANT_GAME_TITLE, INSTANT_SLUG_GAME } from '@/constants/lotto'
import LastResultService from '@/services/last-result.service'
import EventBus from '@/utils/EventBus'
import { isApkCompatibleWithReprintMode } from '@/utils/reprint-mode'
const ACCOUNT = process.env.VUE_APP_ACCOUNT
const IS_DEBUG = process.env.VUE_APP_IS_DEBUG

export default {
    mixins: [languageMixins],
    components: { LoadingScreen },
    data() {
        return {
            appVersion: version,
            ACCOUNT: ACCOUNT,
            IS_DEBUG: IS_DEBUG,
            isLoadingScreen: true,
            isTimeOut: false,
            INSTANT_GAME_TITLE,
            CT_PICK_3
        }
    },
    created() {
        // Returning to the dashboard ends any in-progress FreeBet journey, so a
        // stale freebet context can never leak into a normal Loto 5/90 bet.
        if (this.$store.state.freebetContext) {
            this.$store.commit('CLEAR_FREEBET_CONTEXT')
        }
        this.fetchSetting()
    },
    computed: {
        displayVersion() {
            return this.$store.getters.mappedAppVersionName || version
        },
    },
    methods: {
        async fetchSetting() {
            this.isLoadingScreen = true
            try {
                let setting = await settingService.fetchSetting()
                const cashierGameSlugs = this.$store.state.userInfo?.details?.enabled_game_slugs || ''
                const configGameSlugs = setting.guinee?.enabled_game_slugs || ''
                const enabledGameSlugs = cashierGameSlugs || configGameSlugs

                this.$store.state.isOnlyPayment = isStrEmpty(enabledGameSlugs)

                this.$store.state.isAllowDoubleChance = enabledGameSlugs.indexOf('double_chance') !== -1
                this.$store.state.isShowExtra7Boost = enabledGameSlugs.indexOf('extra7-boost') !== -1
                this.$store.state.isShow645 = enabledGameSlugs.indexOf('lotto-6-45') !== -1
                this.$store.state.isShow590 = enabledGameSlugs.indexOf('lotto-5-90') !== -1
                this.$store.state.isShow459 = enabledGameSlugs.indexOf('loto-4-59') !== -1
                this.$store.state.isShow545 = enabledGameSlugs.indexOf('lotto-5-45') !== -1
                this.$store.state.isShowInstantLotto = enabledGameSlugs.indexOf(INSTANT_SLUG_GAME) !== -1
                this.$store.state.isShowPick3 = enabledGameSlugs.indexOf(CT_PICK_3.SLUG_GAME) !== -1

                this.$store.state.isShowSports = enabledGameSlugs.indexOf('bitville-sports') !== -1
                this.$store.state.isShowVoucher = enabledGameSlugs.indexOf('ludwin-prepaid-voucher') !== -1


                this.$store.state.reprintCountToShowCancel = setting.guinee?.reprint_count_to_show_cancel ? parseInt(setting.guinee?.reprint_count_to_show_cancel) : null
                this.$store.state.showCancelationInPos = setting.guinee?.show_cancelation_in_fe_pos ?? false
                this.$store.state.milisecondsToForceFinishPrinting = setting.guinee?.miliseconds_to_force_finish_printing ? parseInt(setting.guinee?.miliseconds_to_force_finish_printing) : null
                this.$store.state.autoCancelUnprintedCountdownSeconds = setting.guinee?.auto_cancel_unprinted_countdown_seconds
                    ? parseInt(setting.guinee.auto_cancel_unprinted_countdown_seconds, 10)
                    : null
                this.$store.state.usersBypassPrintingCheck = setting.guinee?.users_bypass_printing_check ?? ''
                this.$store.state.usersSimulatePrintError = setting.guinee?.users_simulate_print_error ?? ''
                this.$store.state.printSimulateMode = setting.guinee?.print_simulate_mode ?? 'always-error'
                this.$store.state.autoCancelUnprintedCountdownSeconds = setting.guinee?.auto_cancel_unprinted_countdown_seconds
                    ? parseInt(setting.guinee.auto_cancel_unprinted_countdown_seconds, 10)
                    : null
                this.$store.state.maxAutoReprintAttempts = setting.guinee?.max_auto_reprint_attempts != null
                    ? parseInt(setting.guinee.max_auto_reprint_attempts, 10)
                    : 1
                this.$store.state.usersNewReprintDialog = setting.guinee?.users_new_reprint_dialog ?? ''
                this.$store.state.usingReprintDialog = setting.guinee?.using_new_reprint_dialog ?? false
                this.$store.state.networkTimeoutSeconds = setting.guinee?.network_timeout_seconds ? parseInt(setting.guinee?.network_timeout_seconds) : null

                // Reprint-mode / APK gate: on-list cashiers must run the new APK,
                // off-list cashiers must run the old one. On mismatch, force logout.
                //if (!isApkCompatibleWithReprintMode()) {
                //    EventBus.$emit('show-notications', {
                //        text: this.getTranslatedText('app version not compatible please update'),
                //        type: 'error',
                //    })
                //    await AuthService.logout()
                //    this.$router.push('/login')
                //    return
                //}

                const isShow645 = this.$store.state.isShow645
                const isShow590 = this.$store.state.isShow590
                const isShow459 = this.$store.state.isShow459
                const isShow545 = this.$store.state.isShow545
                const isShowPick3 = this.$store.state.isShowPick3
                const isShowInstantLotto = this.$store.state.isShowInstantLotto

                const filteredData = this.$store.state.cart.filter(
                    (x) => (isShow645 && x.gameType === 'lotto-6-45') 
                    || (isShow590 && x.gameType === 'loto-590') 
                    || (isShow459 && x.gameType === 'loto-4-59') 
                    || (isShow545 && x.gameType === 'lotto-5-45')
                    || (isShowPick3 && x.gameType === CT_PICK_3.SLUG_GAME)
                    || (isShowInstantLotto && x.gameType === INSTANT_SLUG_GAME)
                )

                this.$store.state.quantity = filteredData.length

                setSettingSite(setting)

                const printTimeoutMs = parseInt(setting.guinee?.miliseconds_to_force_finish_printing)
                const sleepSecondsBeforePrint = parseInt(setting.guinee?.sleep_seconds_before_print)
                const settingsPayload = { command: 'settings' }
                if (Number.isInteger(printTimeoutMs)) settingsPayload.printTimeoutMs = printTimeoutMs
                if (Number.isInteger(sleepSecondsBeforePrint)) settingsPayload.sleepSecondsBeforePrint = sleepSecondsBeforePrint
                if (Object.keys(settingsPayload).length > 1) {
                    parent.postMessage(settingsPayload, '*')
                    setTimeout(() => {
                        parent.postMessage({ command: 'get-settings' }, '*')
                    }, 1000)
                }

                this.isLoadingScreen = false
            } catch (error) {
                if (error === 'ECONNABORTED') {
                    this.isTimeOut = true
                }
                this.isLoadingScreen = false

                console.log(error)
            }
        },
        async handleLogout() {
            try {
                await AuthService.logout()
                this.$router.push('/login')
            } catch (error) {
                console.log(error)
            }
        },
        handleTextAppVersion() {
            let v = this.$t(`version ${this.displayVersion}`)
            const isDev = process.env.VUE_APP_IS_DEV
            if(isDev && isDev != '') v += ' - DEV';
            return v;
        },
        onOpenLoto(name, number) {
            this.$store.state.stepCart = parseInt(number)
            LastResultService.warm(LastResultService.typeGameFor(name))
            this.$router.push(name)
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/home/_index.scss';
</style>
